module.exports = __webpack_public_path__ + "static/media/display-3@768.3be98708.png";